"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKAccordion = exports.toggleItemInSet = exports.GKAccordionContext = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
require("./GKAccordion.css");
exports.GKAccordionContext = React.createContext({
    openItems: new Set(),
    toggleItem: function () {
        /** pass */
    },
});
var toggleItemInSet = function (item, initialSet, specificVal, allowMulti) {
    if (allowMulti === void 0) { allowMulti = false; }
    var newSet = new Set(initialSet);
    var targetVal = specificVal !== null && specificVal !== void 0 ? specificVal : !newSet.has(item);
    if (targetVal === true) {
        if (!allowMulti) {
            newSet.clear();
        }
        newSet.add(item);
    }
    else {
        newSet.delete(item);
    }
    return newSet;
};
exports.toggleItemInSet = toggleItemInSet;
var GKAccordion = function (props) {
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-accordion",
    }), children = _a.children, openMultiple = _a.openMultiple, otherProps = __rest(_a, ["children", "openMultiple"]);
    var _b = React.useState(new Set()), openItems = _b[0], setOpenItems = _b[1];
    var toggleItem = function (id, val) {
        setOpenItems(function (previousItems) {
            return (0, exports.toggleItemInSet)(id, previousItems, val, openMultiple);
        });
    };
    return (React.createElement(exports.GKAccordionContext.Provider, { value: { toggleItem: toggleItem, openItems: openItems } },
        React.createElement("div", __assign({}, otherProps),
            " ",
            children,
            " ")));
};
exports.GKAccordion = GKAccordion;
